/**
 * Scrolling — scroll lock utilities for drawers, modals, and overlays.
 */

let scrollLockCount = 0;
let savedScrollY = 0;

/**
 * Lock body scroll (prevents background scrolling when drawer/modal is open)
 * Supports nested locks (multiple drawers/modals open)
 */
export function lockScroll() {
  scrollLockCount++;

  if (scrollLockCount === 1) {
    savedScrollY = window.scrollY;
    document.body.style.setProperty('overflow', 'hidden');
    document.body.style.setProperty('position', 'fixed');
    document.body.style.setProperty('top', `-${savedScrollY}px`);
    document.body.style.setProperty('width', '100%');
  }
}

/**
 * Unlock body scroll
 * Only actually unlocks when all lock holders have released
 */
export function unlockScroll() {
  scrollLockCount = Math.max(0, scrollLockCount - 1);

  if (scrollLockCount === 0) {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('width');
    window.scrollTo({ top: savedScrollY, behavior: 'instant' });
  }
}

/** Force unlock all scroll locks */
export function forceUnlockScroll() {
  scrollLockCount = 0;
  unlockScroll();
}
